export const options = [
  {
    label: "По релевантности",
    value: "default",
  },
  {
    label: "По популярности",
    value: "popular",
  },
  {
    label: "По новизне",
    value: "last",
  },
  {
    label: "По возрастанию цены",
    value: "price_asc",
  },
  {
    label: "По убыванию цены",
    value: "price_desc",
  },
];
